<template>
	<div class="col-lg-8">
		<div class="activity-list ">
			<div class="activity-item text-block">
				<div class="subnav">
					<ul>
						<li v-for="directory in directories.filter(x => x.print !== false)" :key="directory.path">
							<router-link :to="`${basePath}/directories/${directory.path}`">{{ directory.name }}</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import directories from './directories'
import { getConfig } from '@/auth';

export default {
	data() {
		return {
			directories: [],
			basePath: getConfig().basePath
		}
	},
	created() {
		this.directories = directories
	},
}

</script>